import BaseService from './BaseService';

export default class BaseEntityService
    extends BaseService {
  constructor({ baseUrl }) {
    super();

    if (!baseUrl) {
      throw Error('Missing parameter: baseUrl');
    }

    this.baseUrl = baseUrl;
  }

  create() {
    return this.get({
      url: this.baseUrl + '/new'
    });
  }

  find({ parameters, pageRequest, sort }) {
    return this.get({
      url: this.baseUrl,
      queryParams: [
        parameters,
        pageRequest
          ? { page: pageRequest.number - 1, size: pageRequest.size }
          : { page: 0, size: 0 },
        sort
          ? { sort: sort.sort, order: sort.order.toUpperCase() }
          : {}
      ]
    });
  }

  load({ id }) {
    if (!id) {
      throw Error('Missing parameter: id');
    }
    return this.get({
      url: this.baseUrl + '/' + id
    });
  }

  insert({ instance }) {
    if (!instance) {
      throw Error('Missing parameter: instance');
    }
    if (instance.id) {
      throw Error('You should not insert an instance with a defined id');
    }
    return this.post({
      url: this.baseUrl,
      data: instance
    });
  }

  update({ id, instance }) {
    if (!instance) {
      throw Error('Missing parameter: instance');
    }
    /*
    if (!instance.id) {
      throw Error('You should not update an instance with an undefined id');
    }
    */
    return this.put({
      url: this.baseUrl + '/' + id,
      data: instance
    });
  }

  remove({ id }) {
    if (!id) {
      throw Error('Missing parameter: id');
    }
    return this.delete({
      url: this.baseUrl + '/' + id
    });
  }
}
